import { Card, Grid } from '@design-systems/canvas-ui'
import { SectionHeader } from '../globalComponents/SectionHeader'

export const ErrorContent = ({ error }) => {
  return (
    <>
      <SectionHeader pageHeading="Error" />

      <Grid.Container data-testid="layoutWithErrorContent">
        <Grid.Item size={{ xs: 12, md: 8 }}>
          <Card>
            <p>Your error content: {error?.message}</p>
          </Card>
        </Grid.Item>

        <Grid.Item
          size={{ xs: 12, md: 4 }}
          data-testid="layoutWithErrorRailContent"
        >
          <Card>
            <p>Your help content</p>
          </Card>
        </Grid.Item>
      </Grid.Container>
    </>
  )
}
